// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDUXpwjhk-jv97ZMkpqheSgSDqNO_FfpJE",
    authDomain: "ca-winnerschapel-moncton.firebaseapp.com",
    projectId: "ca-winnerschapel-moncton",
    storageBucket: "ca-winnerschapel-moncton.firebasestorage.app",
    messagingSenderId: "562237566963",
    appId: "1:562237566963:web:7727305043fff71fb2ac86",
    measurementId: "G-Z7TLKC04TD"
  },
  churchName:'Winners Chapel International',
  churchLocation:'Moncton, NB',
  mapKey:'AIzaSyBzpVbQnsIBG9iBHSdTpr7kfggR3kdWRi4',
  apiUrl:'https://ca-winnerschapel-moncton-backend-dev-562237566963.northamerica-northeast1.run.app/',
  financeUrl:'https://ca-winnerschapel-moncton-finance-dev-562237566963.northamerica-northeast1.run.app/',
  vapidKey:"BOUfUPyEQR-Jy3sPA1opYxv4Ul_gxfd7BpiUmhpZb16PrEM5ZaVtF1feFu8JYmx1PU_RGxqphWS6_GrNpPxm0aY",
  mcpClient:"https://ccm-mcp-client-dev-3690406590.us-central1.run.app/",
  prefix:'dev_',
  CHURCH_LOCATION_LATITUDE: 46.0962473,
  CHURCH_LOCATION_LONGITUDE: -64.8094917 ,
  endpoints:{
    PHONE:'register',
    ADD_PARENT_TO_CHILDREN:'register/update-parent-phone',
    UPDATE_FROM_OLD:'register/update-by-phone',
    CREATE_EVENT:'event',
    REGISTER_EVENT:'register-event',
    MEMBERS: 'members',
    HOUSE_FELLOWSHIP_MEMBERS:'housefellowship',
    GROUP_ALL_HOUSE_FELLOWSHIP_MEMBERS:'housefellowship/group-members',
    UPDATE_GROUP: 'housefellowship/update-groups',
    ASSIGN_HOUSE_FELLOWSHIP:'housefellowship/assign-member-to-group',
    OVERRIDE_HOUSE_FELLOWSHIP:'housefellowship/override-center',
    LIST_HOUSE_FELLOWSHIP:'create-housefellowship/add',
    UPDATE_MEMBER_PERMISSIONS:'housefellowship/grant-access',
    CREATE_HOUSE_FELLOWSHIP:'create-housefellowship',
    STAGING_MEMBERS: 'members/staging',
    DEPARTMENT_MEMBERS: 'members/department-members',
    UPDATE_PERMISSIONS:'members/update-member-permissions',
    CLOSE_MEMBERS:'members/close-members',
    CREATE_ANNOUNCEMENT:'announcement',
    CREATE_PRAYER_REQUEST: 'prayers',
    UPDATE_TOKEN: 'members/register-token',
    SERMONS:'sermons',
    CREATE_DEPARTMENT:'department',
    DEPARTMENT_ACCESS:'department/grant-department-access',
    CREATE_APPOINTMENT:'appointment',
    DELETE_APPOINTMENT:'appointment/delete',
    DELETE_PERSONAL_APPOINTMENT:'appointment/delete-personal',
    SEND_CHAT_MESSAGE:'chat',
    UPDATE_HOME_MESSAGE:'sermons/home-message',
    TRANSLATE:'translate',
    SEND_MESSAGE:'message',
    SEND_MESSAGE_MEMBER:'message/personal',
    NEW_COMER:'new-comer',
    MANAGE_ATTENDACE:'attendance',
    LIVE_SERVICE:'api/live-videos',
    SEARCH_SERMON:'search-sermon',
    DEVOTION:'devotion',
    DEVOTION_COMMENT:'devotion-comment',
    DEVOTION_READ:'devotion-comment/read',
    CREATE_MEETING:'generate-meeting-code',
    MARK_ATTENDANCE:'mark-attendance',
    DELETE_HOUSEFELLOWSHIP_CENTER:'create-housefellowship/delete',
    QUICKBOOK_DATA:'quickbook-members',
    QUICKBOOK_SEARCH:'quickbook-search',
    QUICKBOOK_UPDATE: 'quickbook-update',
    QUICKBOOK_DONATION:'donation_matching',
    NATURAL_GROUP:'natural-group',
    BANK_TRANSACTION:'transaction/debit-credit',
    MEMBER_CHILDREN:'children',
    UPLOAD_STATEMENT:'process_statement',
    PROCESS_TRANSACTION:'process_transaction',
    PROCESS_EXPENSE:'process_expense',
    MANUAL_DONATION_ENTRY:'donation_entry',
    TRANSPORT_REQUEST:'transport-request',
    MEETING_REPORT:'meeting-report',
    EXPENSE_REPORT:'expenses',
    CREDIT_CARD_REPORT:'creditcard-expenses',
    VEHICLE_REQUEST:"vehicle-request",
    ROUTE_OPTIMIZER:"route-optimizer",
    UNLISTED_SERMONS:"unlisted-sermon",
    DYNAMIC_FORM:"form",
    INDIVIDUAL_SCHEDULLING:"schedule",
    INDIVIDUAL_ACTIVITY:"activity",
    BUDGET_REPORT:"budget",
    ADVANCE_EXPENSE_REPORT:"advance-request",
    DASHBOARD_ATTENDANCE_REPORT: "dashboard-data",
    ABSENCES:'absences'

    






  },
  collections:{
    USERS:'members',
    FORM_FIELDS:'variables',
    EVENTS:'events',
    ANNOUNCEMENT: 'announcements',
    PRAYER_REQUESTS: 'prayers',
    SERMONS:'sermons',
    DEPARTMENT:'department',
    BIRTHDAYS:'upcoming_birthdays',
    ATTENDANCE:'attendance',
    DEVOTION:'bible_reading',
    PASTORAL_SCHEDULE:'pastoral_schedule',
    HOUSE_FELLOWSHIP:'houseFellowshipCenters',
    HOUSE_FELLOWSHIP_CENTERS:'houseFellowshipCenters',
    HOUSE_FELLOWSHIP_GROUPED_CENTERS:'hf_grouping',
    NATURAL_GROUP:'natural_group',
    MEETINGS:'meetings',
    MARK_ATTENDANCE:'mark-attendance',
    CHILDREN:'members_children',
    ATTENDANCE_SUMMARY:'general_meetings_attendance_summary',
    GENERAL_MEETINGS:'general_meetings',
    TRACKER_SUMMARY:'transaction_upload_tracker',
    MANUAL_DONATION_ENTRY:'manual_donation_summary',
    CREDIT_TRANSACTION:'credit_bank_transactions',
    DEBIT_TRANSACTION:'debit_bank_transactions',
    MANUAL_TRANSACTION:'manual_donation_entry',
    MONTHLY_BIRTHDAYS:'upcoming_birthMonth',
    MONTHLY_ANNIVERSARY:'upcoming_anniversaryMonth',
    ANNIVERSARIES:"upcoming_anniversary",
    CREDIT_CARD_EXPENSE:'credit_card_expenses',
    VEHICLE_REQUEST:"vehicle_requests",
    TRANSPORT_REQUEST:"transport_request",
    TRANSPORT_REQUEST_ROUTE:"transport_request_routes",
    DYNAMIC_FORM_SCHEMA:"form_schemas",
    DYNAMIC_FORM_SUBMISSIONS:"form_submissions",
    INDIVIDUAL_SCHEDULLING:"appointment_schedules",
    INDIVIDUAL_ACTIVITY:"activity_types",
    EXPENSE_REPORT:'expenses',
    ADVANCE_EXPENSE_REPORT:'expense_advances',
    ABSENCES:'absence'
    




    
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
